export default __webpack_public_path__ + "a00946342ff525f089ec581d65465acb.png";